import SmartFeedEngine from "~/smart-feed/smart-feed-engine";
import App from "@bloglovin/inspire-engine/App";
import { contextualAppName } from "%/dynamic-component-editor/classes/platform-standard-entities";
import {
  SmartFeedEntityDynamicElementMixin,
} from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";

const AFFILIATE_LINK_ENTITY_TYPE = "AffiliateLink";

function feedV2Product(id) {
  const app = App.get(contextualAppName());
  if (!app.hasEntity(AFFILIATE_LINK_ENTITY_TYPE, { id })) {
    return null;
  }
  const entity = app.getEntity(AFFILIATE_LINK_ENTITY_TYPE, { id });
  return entity?.isHydrated ? entity : null;
}

const EMPTY_AFFILIATE_LINK_ENTITY = Object.freeze({
  shortLinkId: 0,
  affiliateLink: "",
  originalLink: "",
  advertiserOrgId: 0,
  advertiserName: "",
  clicks: 0,
  currency: "",
  lockedEarnings: 0,
  pendingEarnings: 0,
  totalEarnings: 0,
  salesCount: 0,
  salesAmount: 0,
  productName: "",
  productPrice: 0,
  productDescription: "",
  brandName: "",
  productImageUrl: "",
  notes: "",
  status: "",
});

export const BaseAffiliateLinkElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    scopedProvidedContexts: { default: null },
    useExampleData: { default: () => () => false },
  },
  entityStore: SmartFeedEngine.getEntityPiniaStore("affiliateLink"),
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    affiliateLinkEntityId() {
      if (this.entityId !== undefined && this.entityId !== null && this.entityId !== 0 && this.entityId !== "0") {
        return this.entityId;
      }
      const scoped = typeof this.scopedProvidedContexts === "function" ? this.scopedProvidedContexts() : null;
      const fromScopedContext = scoped?.affiliateLink?.entityPkUrlVars?.id ?? scoped?.affiliateLink?.pk?.id;
      if (fromScopedContext) {
        return Number(fromScopedContext) || fromScopedContext;
      }
      const fromPage = typeof this.pageEntities === "function"
        ? this.pageEntities()?.affiliateLink
        : this.pageEntities?.affiliateLink;
      if (fromPage) {
        return Number(fromPage) || fromPage;
      }
      return 0;
    },
  },
  methods: {
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.getExampleEntity();
      }
      const id = this.affiliateLinkEntityId;
      if (!id) {
        return EMPTY_AFFILIATE_LINK_ENTITY;
      }
      return feedV2Product(Number(id) || id)
        ?? this.getSmartFeedEntityStore()?.entities?.[id]
        ?? EMPTY_AFFILIATE_LINK_ENTITY;
    },
  },
  exampleEntity: {
    "shortLinkId": 0,
    "affiliateLink": "#",
    "originalLink": "#",
    "advertiserOrgId": 0,
    "advertiserName": "",
    "clicks": 12,
    "currency": "USD",
    "lockedEarnings": 800,
    "pendingEarnings": 400,
    "totalEarnings": 1200,
    "salesCount": 4,
    "salesAmount": 300,
    "productName": "Demo Product",
    "productPrice": 100,
    "productDescription": "Demo Product Description",
    "brandName": "Demo Brand",
    "productImageUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/fashion-story-sample-image.webp",
    "notes": "",
    "status": "active",
  },
};
